import { HttpClient } from '@angular/common/http'
import { inject, Injectable, signal } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

import { environment } from '../../../environments/environment'
import { UiSkinKey } from '../../skins/skin.type'
import { resolveUiSkinKey } from '../../skins/skin-registry'
import { ApiResponse } from '../types/response.type'
import { DomainService } from './domain.service'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class WhiteLabelService {
	http = inject(HttpClient)

	domainService = inject(DomainService)

	isSelfRegistrationEnabled = signal<boolean>(false)

	isTurnstileEnabled = signal<boolean>(false)

	uiSkinKey = signal<UiSkinKey>('v1')

	activeSkin(): UiSkinKey {
		return this.uiSkinKey()
	}

	fetchPermissions(): Observable<
		ApiResponse<{ SELF_REGISTER_ALLOWED: boolean; LOGIN_HUMAN_VERIFICATION?: boolean; UI_SKIN_KEY?: string; ui_skin_key?: string }[]>
	> {
		return this.http
			.get<
				ApiResponse<{ SELF_REGISTER_ALLOWED: boolean; LOGIN_HUMAN_VERIFICATION?: boolean; UI_SKIN_KEY?: string; ui_skin_key?: string }[]>
			>(`${API_URL}/api/white_label/get_permission/${this.domainService.domain}`)
			.pipe(
				tap((response) => {
					if (response?.status === 'ok') {
						const selfRegistrationEnabled = response?.result?.[0]?.SELF_REGISTER_ALLOWED ?? false
						this.isSelfRegistrationEnabled.set(selfRegistrationEnabled)
						const turnstileEnabled = !!response?.result?.[0]?.LOGIN_HUMAN_VERIFICATION
						this.isTurnstileEnabled.set(turnstileEnabled)
						this.uiSkinKey.set(resolveUiSkinKey(response?.result?.[0]?.UI_SKIN_KEY ?? response?.result?.[0]?.ui_skin_key))
					}
				}),
			)
	}

	isDefaultSkin(): boolean {
		return this.uiSkinKey() === 'v1'
	}

	isV2Skin(): boolean {
		return this.uiSkinKey() === 'v2'
	}

	isV3Skin(): boolean {
		return this.uiSkinKey() === 'v3'
	}
}
